import RevenueReportFeature from "@/features/RevenueReport";

export default function RevenuePage() {
  return (
    <main className="md:w-[80vw] lg:w-[70vw] mx-auto pb-25 ">
      <RevenueReportFeature />
    </main>
  );
}
